<template>
  <onboarding-organization-information/>
</template>

<script>
import OnboardingOrganizationInformation from '../../../components/Onboarding/OrganizationInformation/index'
export default {
    components: {
        OnboardingOrganizationInformation
    }
}
</script>

<style>

</style>